import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'

import './ProductReceiving.scss'
import { redirect } from '../../common/utils/redirectionUtils'
import {
    ADD_PRODUCT_RECEIVING_STAGES,
    BILL_DETAILS_FIELDS,
    PAGE_CONST,
    PAYMENT_DETAILS_FIELDS,
    PAYMENT_MODE_OPTIONS_PRODUCT_RECEIVING,
    PERMISSION_FEATURE,
    PERMISSION_SCREEN,
    PERMISSION_TYPE,
    PRODUCT_DETAIL_FIELDS,
    PRODUCT_RECEIVING_TYPE
} from '../../common/constant/page-constant'
import Card from '../Common/Card/Card'
import SideDrawer from '../Common/SideDrawer/SideDrawer'
import TrashIcon from '../../assets/TrashIcon'
import ArrowDown from '../../assets/ArrowDown'
import AddProduct from './AddProduct'
import ViewProduct from './ViewProduct'
import WizardSteps from '../../components/WizardSteps/WizardSteps'
import {
    HEADER_CONFIG,
    HEADER_CONST,
    WIZARD_STEPS
} from '../../common/constant/common-constant'
import AddIcon from '../../assets/AddIcon'
import CloseIcon from '../../assets/CloseIcon'
import Alert from '../../components/Alert/Alert'
import {
    addProductReceivingHelper,
    getInvoiceDetailsHelper,
    getMedicalCategoryHelper,
    getProductDataHelper,
    getProductReceivingHelper,
    getProductsHelper,
    getSuppliersHelper,
    updateProductDataHelper,
    updateSuppliersHelper,
    updateProductReceivingStatusHelper,
    deleteProductReceivingHelper
} from '../../helper/home-helper'
import { addProductReceivingAlertAction } from '../../modules/actions/action'
import ProductReceivingBlack from '../../assets/ProductReceivingBlack'
import ViewInventory from '../ManageInventory/ViewInventory'
import Header from '../Common/Header/Header'
import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import CheckPrimaryIcon from '../../assets/CheckPrimaryIcon'
import AcknowledgeScreen from '../Common/AcknowledgeScreen/AcknowledgeScreen'
import PopupCard from '../Common/PopupCard/PopupCard'
import AddProductReceiving from './AddProductReceiving'
import ProductReceivingFilter from './components/ProductReceivingFilter'

function ProductReceiving(props) {
    const navigate = useNavigate()
    const isMobile = useCheckMobileScreen()

    const [viewDrawer, setViewDrawer] = useState(false)
    const [open, setOpen] = useState(false)
    const [isViewInventoryActive, setViewInventoryActive] = useState(false)
    const [addProductReceivingAlert, setAddProductReceivingAlert] =
        useState(false)
    const [productReceivingData, setProductReceivingData] = useState(undefined)
    const [allProductReceivingData, setAllProductReceivingData] = useState([])
    const [stats, setStats] = useState({})
    const [invoiceData, setInvoiceData] = useState(null)
    const [editingData, setEditingData] = useState(null)
    const [activeReceivingTab, setActiveReceivingTab] = useState(PRODUCT_RECEIVING_TYPE.HOLD)
    const [headerOptions, setHeaderOptions] = useState({
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.PRODUCT_RECEIVING,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () =>
            redirect(navigate, PAGE_CONST.HOME)
    })
    const [loginData, setLoginData] = useState({})
    const [permissions, setPermissions] = useState({})
    const [serverError, setServerError] = useState(undefined)
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)
    const [deleteInvoicePopup, setDeleteInvoicePopup] = useState(false)
    const [isDeletingInvoice, setIsDeletingInvoice] = useState(false)
    const [confirmInvoicePopup, setConfirmInvoicePopup] = useState(false)
    const [isConfirmingInvoice, setIsConfirmingInvoice] = useState(false)
    const [filterOptions, setFilterOptions] = useState({ search: '' })

    const updateFilterOptions = (newOptions) => {
        setFilterOptions((prev) => ({
            ...prev,
            ...newOptions
        }))
    }

    useEffect(() => {
        let addProductReceivingAlert = props.alert?.addProductReceivingAlert
        setAddProductReceivingAlert(addProductReceivingAlert)
    }, [props.alert?.addProductReceivingAlert])

    useEffect(() => {
        setLoginData(props.loginData)

        if (props.loginData.permissions) {
            let permission = props.loginData.permissions.reduce(
                (acc, permission) => {
                    acc.features = {
                        ...acc.features,
                        ...permission.features
                    }

                    return acc
                },
                {}
            )

            if (permission) setPermissions(permission)
        }
    }, [props.loginData])


    useEffect(() => {
        if (!open && !isViewInventoryActive) {
            handleHeaderConfigUpdate(HEADER_CONST.PRODUCT_RECEIVING, () =>
                redirect(navigate, PAGE_CONST.HOME)
            )
            return
        }

        if (open) {
            handleHeaderConfigUpdate(HEADER_CONST.ADD_PRODUCT_RECEIVING, () =>
                handleDrawerToggle()
            )
        } else if (isViewInventoryActive) {
            handleHeaderConfigUpdate(HEADER_CONST.VIEW_PRODUCT_RECEIVING, () =>
                setViewInventoryActive(!isViewInventoryActive)
            )
        }
    }, [open, isViewInventoryActive])


    useEffect(() => {
        getProductReceiving()
    }, [])


    // Filter data based on active tab and search
    useEffect(() => {
        if (allProductReceivingData.length > 0) {
            let filteredData = allProductReceivingData.filter(item => {
                // Filter by tab
                let matchesTab = true
                if (activeReceivingTab === PRODUCT_RECEIVING_TYPE.HOLD) {
                    matchesTab = item.status === PRODUCT_RECEIVING_TYPE.HOLD || !item.status
                } else if (activeReceivingTab === PRODUCT_RECEIVING_TYPE.RECEIVED) {
                    matchesTab = item.status === PRODUCT_RECEIVING_TYPE.RECEIVED
                }
                
                // Filter by search term (invoice number)
                let matchesSearch = true
                if (filterOptions.search && filterOptions.search.trim() !== '') {
                    const searchTerm = filterOptions.search.toLowerCase().trim()
                    matchesSearch = item.invoice_number?.toLowerCase().includes(searchTerm)
                }
                
                return matchesTab && matchesSearch
            })
            setProductReceivingData(filteredData)
        } else {
            setProductReceivingData([])
        }
    }, [activeReceivingTab, allProductReceivingData, filterOptions])

    const handleHeaderConfigUpdate = (title, handleBackFunc) => {
        setHeaderOptions({
            [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
            [HEADER_CONFIG.TITLE]: title,
            [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => handleBackFunc()
        })
    }

    const getProductReceiving = () => {
        getProductReceivingHelper({})
            .then(res => {
                let pReceivings = res.product_receivings
                setStats(res.stats)
                setAllProductReceivingData(pReceivings || [])
                setProductReceivingData(pReceivings || [])
            })
            .catch(err => {
                setStats({})
                setAllProductReceivingData([])
                setProductReceivingData([])
            })
    }

    const handleSubmit = async data => {
        setServerError(undefined)

        try {
            let res = await addProductReceivingHelper(data)

            props.addProductReceivingAlertAction(true)
            setTimeout(() => {
                props.addProductReceivingAlertAction(false)
            }, 5000)
            getProductReceiving()
            handleDrawerToggle()
        } catch (errMsg) {
            setServerError(errMsg)
        }
    }


    const getInvoiceDetails = id => {
        if (!id) {
            return
        }

        getInvoiceDetailsHelper(id)
            .then(res => {
                setInvoiceData(res)
                setViewInventoryActive(true)
            })
            .catch(err => {
                // Handle error silently
            })
    }

    const handleDrawerToggle = () => {
        setViewDrawer(!viewDrawer)
        setOpen(!open)
        if (open) {
            setEditingData(null)
        }
    }

    const handleAddNewReceiving = () => {
        navigate('/home/productReceiving/new')
    }

    const handleCardAction = (action, productReceiving) => {
        switch (action) {
            case 'EDIT':
                handleEditProductReceiving(productReceiving)
                break
            case 'CONFIRM':
                handleConfirmProductReceiving(productReceiving)
                break
            case 'REMOVE':
                handleRemoveInvoice(productReceiving)
                break
            case 'DOWNLOAD':
                handleDownloadInvoice(productReceiving)
                break
            case 'PRINT':
                handlePrintInvoice(productReceiving)
                break
            default:
                break
        }
    }

    const handleEditProductReceiving = async (productReceiving) => {
        navigate(`/home/productReceiving/edit/${productReceiving.id}`)
    }

    const handleConfirmProductReceiving = (productReceiving) => {
        setConfirmInvoicePopup(productReceiving)
    }

    const handleConfirmInvoice = async (productReceiving) => {
        if (isConfirmingInvoice) {
            alert('Another confirm operation is in progress. Please wait.')
            return
        }

        if (!loginData || !loginData.id) {
            alert('Unable to identify logged-in user. Please refresh and try again.')
            return
        }

        setIsConfirmingInvoice(true)
        
        try {
            await updateProductReceivingStatus(
                productReceiving.id, 
                PRODUCT_RECEIVING_TYPE.RECEIVED, 
                loginData.id
            )
            
            setConfirmInvoicePopup(false)
            
        } catch (error) {
            alert(`Failed to confirm invoice: ${error}. Please try again.`)
        } finally {
            setIsConfirmingInvoice(false)
        }
    }

    const handleRemoveInvoice = (productReceiving) => {
        setDeleteInvoicePopup(productReceiving)
    }

    const handleDeleteInvoice = async (productReceiving) => {
        if (isDeletingInvoice) {
            alert('Another delete operation is in progress. Please wait.')
            return
        }

        setIsDeletingInvoice(true)
        
        try {
            const requestData = {
                product_receiving_id: productReceiving.id
            }
            const result = await deleteProductReceivingHelper(requestData)
            
            alert(`${result.message}!`)
            
            setDeleteInvoicePopup(false)
            
            getProductReceiving()
            
        } catch (error) {
            alert(`Failed to delete invoice: ${error}. Please try again.`)
        } finally {
            setIsDeletingInvoice(false)
        }
    }

    const updateProductReceivingStatus = async (id, newStatus, receiverId = null) => {
        if (isUpdatingStatus) {
            alert('Another status update is in progress. Please wait.')
            return
        }

        setIsUpdatingStatus(true)
        
        try {
            const requestData = {
                product_receiving_id: id,
                status: newStatus
            }

            if (receiverId) {
                requestData.received_by_user_id = receiverId
            }
            
            await updateProductReceivingStatusHelper(requestData)
            
            const updatedData = allProductReceivingData.map(item => 
                item.id === id ? { ...item, status: newStatus } : item
            )
            setAllProductReceivingData(updatedData)
            
            getProductReceiving()
            
        } catch (error) {
            alert(`Failed to update status: ${error}. Please try again.`)
        } finally {
            setIsUpdatingStatus(false)
        }
    }

    const handleDownloadInvoice = async (productReceiving) => {
        const data = await getInvoiceDetailsHelper(productReceiving.id)
        if (data) {
            downloadInvoiceAsPDF(data)
        }
    }

    const handlePrintInvoice = async (productReceiving) => {
        const data = await getInvoiceDetailsHelper(productReceiving.id)
        if (data) {
            printInvoice(data)
        }
    }

    const downloadInvoiceAsPDF = (data) => {
        const element = document.createElement('a')
        const content = generateInvoiceHTML(data)
        const file = new Blob([content], { type: 'text/html' })
        element.href = URL.createObjectURL(file)
        element.download = `invoice-${data.invoice_number}.html`
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
        alert(`Invoice ${data.invoice_number} downloaded successfully!`)
    }

    const formatInvoiceDate = (dateString) => {
        if (!dateString) return 'N/A'
        const date = new Date(dateString)
        const day = String(date.getDate()).padStart(2, '0')
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const month = monthNames[date.getMonth()]
        const year = String(date.getFullYear()).slice(-2)
        return `${day}-${month}-${year}`
    }

    const formatInvoiceTime = (timeString) => {
        if (!timeString) return 'N/A'
        
        let hours, minutes, seconds
        
        if (typeof timeString === 'string' && timeString.includes(':')) {
            const timeMatch = timeString.match(/(\d+):(\d+):(\d+)/)
            if (timeMatch) {
                hours = parseInt(timeMatch[1])
                minutes = timeMatch[2]
                seconds = timeMatch[3]
            } else {
                const timeMatch2 = timeString.match(/(\d+):(\d+)/)
                if (timeMatch2) {
                    hours = parseInt(timeMatch2[1])
                    minutes = timeMatch2[2]
                    seconds = '00'
                } else {
                    return timeString
                }
            }
        } else {
            const date = new Date(timeString)
            hours = date.getHours()
            minutes = String(date.getMinutes()).padStart(2, '0')
            seconds = String(date.getSeconds()).padStart(2, '0')
        }
        
        const ampm = hours >= 12 ? 'PM' : 'AM'
        hours = hours % 12
        hours = hours ? hours : 12
        return `${hours}:${minutes}:${seconds} ${ampm}`
    }

    const printInvoice = (data) => {
        const printWindow = window.open('', '_blank')
        const content = generateInvoiceHTML(data)
        printWindow.document.write(content)
        printWindow.document.close()
        printWindow.print()
    }

    const generateInvoiceHTML = (data) => {
        const hasVendor = data.vendor_details && data.vendor_details !== null
        const supplierInfo = data.pharma_details
        const vendorInfo = data.vendor_details

        return `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Invoice ${data.invoice_number}</title>
                <meta charset="UTF-8">
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    .header { text-align: left; margin-bottom: 30px; }
                    .invoice-details { margin-bottom: 20px; display: flex; justify-content: space-between; }
                    .invoice-details-left { text-align: left; }
                    .invoice-details-right { text-align: right; }
                    .invoice-details h4 { margin: 5px 0; }
                    .invoice-details p { margin: 5px 0; }
                    .supplier-info { margin-bottom: 20px; padding: 10px; background-color: #f9f9f9; text-align: center; }
                    table { width: 100%; border-collapse: collapse; margin-bottom: 20px; font-size: 11px; }
                    th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                    th { background-color: #f2f2f2; font-weight: bold; }
                    .total-section { margin-top: 20px; }
                    .total-row { display: flex; justify-content: space-between; padding: 5px 0; }
                    .total { font-weight: bold; font-size: 14px; }
                    .text-right { text-align: right; }
                    .notes { margin-top: 30px; padding: 10px; background-color: #f9f9f9; }
                </style>
            </head>
            <body>
                <div class="header">
                    <h2>Product Receiving Invoice</h2>
                </div>
                <div class="supplier-info">
                    ${hasVendor ? `
                        <h3>${vendorInfo.name}</h3>
                        ${vendorInfo.contact ? `<p>${vendorInfo.contact}</p>` : ''}
                        ${vendorInfo.address ? `<p>${vendorInfo.address}</p>` : ''}
                    ` : `
                        <h3>${supplierInfo.name}</h3>
                        ${supplierInfo.mobile_no ? `<p>${supplierInfo.mobile_no}</p>` : ''}
                        ${supplierInfo.address ? `<p>${supplierInfo.address}</p>` : ''}
                    `}
                </div>
                <div class="invoice-details">
                    <div class="invoice-details-left">
                        <h4><strong>Received by:</strong> ${data.created_by}</h4>
                        <p><strong>Invoice No:</strong> ${data.invoice_number}</p>
                    </div>
                    <div class="invoice-details-right">
                        <p><strong>Date:</strong> ${formatInvoiceDate(data.date_of_bill)}</p>
                        <p><strong>Time:</strong> ${formatInvoiceTime(data.time_of_bill || data.date_of_bill)}</p>
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>SL No</th>
                            <th>Product Name (Size)-Strength</th>
                            <th>Category</th>
                            <th>Batch No</th>
                            <th>Expiry Date</th>
                            <th>Qty</th>
                            <th>Bonus Qty</th>
                            <th class="text-right">CPU</th>
                            <th class="text-right">RPU</th>
                            <th class="text-right">Sub total</th>
                            ${hasVendor ? '<th>Suppliers/Manufacturer</th>' : ''}
                        </tr>
                    </thead>
                    <tbody>
                        ${(() => {
                            // Calculate totals for footer row
                            let totalQty = 0;
                            let totalBonusQty = 0;
                            let totalSubtotalSum = 0;
                            
                            const rows = data.product_details?.map((product, index) => {
                                const quantity = parseFloat(product.quantity || 0);
                                const bonusQty = parseFloat(product.bonus_quantity || 0);
                                const cpu = parseFloat(product.cost_per_unit || 0);
                                const rpu = parseFloat(product.rate_per_unit || 0);
                                const subtotal = quantity * cpu;
                                
                                totalQty += quantity;
                                totalBonusQty += bonusQty;
                                totalSubtotalSum += subtotal;
                                
                                // Format: Product Name (Size)-Strength or Product Name-Strength
                                const productName = product.product_name || '';
                                const size = product.dose || '';
                                const strength = product.strength || '';
                                let formattedName = productName;
                                if (size) formattedName += `-${size}`;
                                if (strength) formattedName += `-${strength}`;
                                if (!product.is_approved) formattedName += ' *';
                                
                                return `
                            <tr>
                                <td>${index + 1}</td>
                                <td>${formattedName}</td>
                                <td>${product.category || ''}</td>
                                <td>${product.batch_number || ''}</td>
                                <td>${product.expiry_date ? new Date(product.expiry_date).toLocaleDateString('en-GB', {day: '2-digit', month: 'short', year: 'numeric'}) : ''}</td>
                                <td>${quantity}</td>
                                <td>${bonusQty}</td>
                                <td class="text-right">${cpu.toFixed(2)}</td>
                                <td class="text-right">${rpu.toFixed(2)}</td>
                                <td class="text-right">${subtotal.toFixed(2)}</td>
                                ${hasVendor ? `<td>${product.supplier_name || ''}</td>` : ''}
                            </tr>
                        `}).join('') || '';
                            
                            // Add total row
                            const totalRow = `
                            <tr style="font-weight: bold;">
                                <td colspan="5" style="text-align: right;">Total</td>
                                <td>${totalQty}</td>
                                <td>${totalBonusQty}</td>
                                <td colspan="2"></td>
                                <td class="text-right">${totalSubtotalSum.toFixed(2)}</td>
                                ${hasVendor ? '<td></td>' : ''}
                            </tr>`;
                            
                            return rows + totalRow;
                        })()}
                    </tbody>
                </table>
                <div class="total-section" style="display: flex; flex-direction: column; align-items: flex-end;">
                    <div class="total-row" style="display: flex; gap: 20px;">
                        <span>Amount (BDT):</span>
                        <span style="min-width: 100px; text-align: right;"><strong>${parseFloat(data.amount || 0).toFixed(2)}</strong></span>
                    </div>
                    <div class="total-row" style="display: flex; gap: 20px;">
                        <span>Total VAT (BDT):</span>
                        <span style="min-width: 100px; text-align: right;"><strong>${parseFloat(data.vat || 0).toFixed(2)}</strong></span>
                    </div>
                    <div class="total-row" style="display: flex; gap: 20px;">
                        <span>Trade Discount (${data.trade_discount_percentage || 0}%):</span>
                        <span style="min-width: 100px; text-align: right;"><strong>${parseFloat(data.trade_discount_amount || 0).toFixed(2)}</strong></span>
                    </div>
                    <div class="total-row" style="display: flex; gap: 20px;">
                        <span>Total (BDT):</span>
                        <span style="min-width: 100px; text-align: right;"><strong>${parseFloat(data.total_amount || 0).toFixed(2)}</strong></span>
                    </div>
                    ${data.payment_mode ? `
                    <div class="total-row" style="display: flex; gap: 20px; margin-top: 10px;">
                        <span>Payment Mode:</span>
                        <span style="min-width: 100px; text-align: right;"><strong>${PAYMENT_MODE_OPTIONS_PRODUCT_RECEIVING.find(item => item.name === data.payment_mode)?.label || data.payment_mode}${data.payment_mode === 'CASH_IN_ACCOUNT' && data.bank_name ? ` - ${data.bank_name}` : ''}</strong></span>
                    </div>
                    ` : ''}
                </div>
                <div class="notes">
                    <p><strong>Notes:</strong></p>
                    <p>${data.notes || ''}</p>
                    ${data.product_details?.some(product => !product.is_approved) ? '<p style="margin-top: 15px; color: #d9534f;"><strong>* marked products require approval from DG HealthCare</strong></p>' : ''}
                    ${!data.pharma_details?.is_approved ? '<p style="margin-top: 10px; color: #d9534f;"><strong>Supplier approval pending from DG HealthCare</strong></p>' : ''}
                </div>
            </body>
            </html>
        `
    }

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}
            {addProductReceivingAlert && (
                <AcknowledgeScreen
                    icon={<CheckPrimaryIcon />}
                    alertType="success"
                    alertMessage="New Product Receiving added Successfully!"
                    main="New Product Receiving added Successfully!"
                    sub="Lorem ipsum dolor sit amet consectetur. Ligula ut volutpat morbi ullamcorper"
                />
            )}
            <div className="pageBodyRightPanel">
                <div className="addProductBtnMobile dFlex aiCenter mwebVisible fixed">
                    <button
                        className="animated zoomIn btn btnPrimary"
                        onClick={handleAddNewReceiving}>
                        <AddIcon />
                    </button>
                </div>
                <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter webVisible mb-5">
                    <div className="pageBodyRightPanelHeading">
                        Product Receiving
                    </div>
                    <div className="addProductBtn dFlex aiCenter">
                        {permissions?.features?.[
                            PERMISSION_FEATURE.PRODUCT_RECEIVING
                        ] === PERMISSION_TYPE.MANAGE && (
                            <button
                                className="btn btnPrimary"
                                onClick={handleAddNewReceiving}>
                                ADD
                            </button>
                        )}
                        <div
                            className="pointer ml-4"
                            onClick={() => props.onClose()}>
                            <CloseIcon />
                        </div>
                    </div>
                </div>
                <div className="consolidateStrip dFlex jcSpaceBetween aiCenter">
                    <div className="consolidateDataIcon dFlex">
                        <ProductReceivingBlack />
                    </div>
                    <div className="consolidateDataText">
                        Purchase({stats?.month_name}) <small>BDT</small>
                    </div>
                    <div className="consolidateData">
                        {stats?.total_amount?.total_amount}
                    </div>
                </div>
                
                {/* Search Filter */}
                <ProductReceivingFilter
                    filterOptions={filterOptions}
                    setFilterOptions={updateFilterOptions}
                />
                
                {/* Tab Navigation */}
                <div className="productReceivingWrapper mt-5">
                    <ul className="tabs dFlex">
                        <li
                            className={`tabItem ${
                                activeReceivingTab === PRODUCT_RECEIVING_TYPE.HOLD
                                    ? 'active'
                                    : ''
                            }`}
                            onClick={() =>
                                setActiveReceivingTab(PRODUCT_RECEIVING_TYPE.HOLD)
                            }>
                            Hold
                        </li>
                        <li
                            className={`tabItem ${
                                activeReceivingTab === PRODUCT_RECEIVING_TYPE.RECEIVED
                                    ? 'active'
                                    : ''
                            }`}
                            onClick={() =>
                                setActiveReceivingTab(PRODUCT_RECEIVING_TYPE.RECEIVED)
                            }>
                            Received
                        </li>
                    </ul>
                    <div className="tabContent">
                        <div className="tabPane dFlex">
                            {productReceivingData &&
                                productReceivingData.map((productReceiving, index) => {
                                    const isHoldTab = activeReceivingTab === PRODUCT_RECEIVING_TYPE.HOLD
                                    const isReceivedTab = activeReceivingTab === PRODUCT_RECEIVING_TYPE.RECEIVED
                                    const hasManagePermission = permissions?.features?.[PERMISSION_FEATURE.PRODUCT_RECEIVING] === PERMISSION_TYPE.MANAGE
                                    const hasViewPermission = permissions?.features?.[PERMISSION_FEATURE.PRODUCT_RECEIVING] === PERMISSION_TYPE.VIEW
                                    
                                    let cardActions = []
                                    if (isHoldTab) {
                                        if (hasViewPermission || hasManagePermission) {
                                            cardActions.push('EDIT')
                                        }
                                        if (hasManagePermission) {
                                            cardActions.push('CONFIRM', 'REMOVE')
                                        }
                                    } else if (isReceivedTab) {
                                        cardActions.push('DOWNLOAD', 'PRINT')
                                    }

                                    // Build sales display content with "Received by" as separate line (like Sales "Served by")
                                    // Display vendor name if available, otherwise supplier name
                                    // Check multiple possible field names for vendor
                                    const vendorName = productReceiving.vendor_name 
                                        || productReceiving.vendor?.name 
                                        || productReceiving.vendor_details?.name
                                    const supplierName = productReceiving.supplier_name 
                                        || productReceiving.pharma_details?.name
                                    
                                    let salesDisplayContent = null
                                    if (isHoldTab) {
                                        // Prioritize vendor name over supplier name
                                        const displayName = vendorName 
                                            ? `Vendor: ${vendorName}` 
                                            : supplierName 
                                                ? `Supplier: ${supplierName}` 
                                                : 'N/A'
                                        salesDisplayContent = displayName
                                    } else if (isReceivedTab) {
                                        // Prioritize vendor name over supplier name
                                        const displayName = vendorName 
                                            ? `Vendor: ${vendorName}` 
                                            : supplierName 
                                                ? `Supplier: ${supplierName}` 
                                                : 'N/A'
                                        
                                        // Display "Received by" on separate line with same style as Sales "Served by"
                                        salesDisplayContent = (
                                            <>
                                                <div>{displayName}</div>
                                                {productReceiving.received_by_name && (
                                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                                                        Received by: {productReceiving.received_by_name}
                                                    </div>
                                                )}
                                            </>
                                        )
                                    }

                                    return (
                                        <div key={`product-receiving-${productReceiving.id || index}`} className="cardWrap">
                                            <Card
                                                cardCrown={
                                                    isReceivedTab ? 'Received' : 'Hold'
                                                }
                                                primary={
                                                    productReceiving.status === PRODUCT_RECEIVING_TYPE.RECEIVED
                                                }
                                                headerSup={
                                                    productReceiving.date_of_bill
                                                }
                                                headerMain={
                                                    productReceiving.invoice_number
                                                }
                                                sales={salesDisplayContent}
                                                cardRight={`BDT ${Number(
                                                    parseFloat(
                                                        productReceiving.total_amount
                                                    ).toFixed(2)
                                                )}`}
                                                handleClick={(e) => {
                                                    if (e) {
                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                    }
                                                    getInvoiceDetails(productReceiving.id)
                                                }}
                                                users={cardActions.length > 0}
                                                cardAction={cardActions}
                                                onCardAction={(action) => handleCardAction(action, productReceiving)}
                                            />
                                        </div>
                                    )
                                })}
                        </div>
                    </div>
                </div>
            </div>

            {open && (
                <AddProductReceiving
                    open={open}
                    handleDrawerToggle={handleDrawerToggle}
                    handleSubmit={handleSubmit}
                    serverError={serverError}
                    editData={editingData}
                />
            )}

            <ViewInventory
                open={isViewInventoryActive}
                handleDrawerToggle={() => setViewInventoryActive(!isViewInventoryActive)}
                invoiceData={invoiceData}
            />

            {deleteInvoicePopup && (
                <PopupCard
                    header={`Delete Invoice ${deleteInvoicePopup.invoice_number}`}
                    body={`Are you sure you want to permanently delete invoice ${deleteInvoicePopup.invoice_number} for ${deleteInvoicePopup.supplier_name}? This action cannot be undone.`}>
                    <button
                        className="btn btnPrimaryOutlined dFlex"
                        onClick={() => setDeleteInvoicePopup(false)}
                        disabled={isDeletingInvoice}>
                        Cancel
                    </button>
                    <button
                        className="btn btnDanger dFlex"
                        onClick={() => handleDeleteInvoice(deleteInvoicePopup)}
                        disabled={isDeletingInvoice}>
                        {isDeletingInvoice ? 'Deleting...' : 'Delete Invoice'}
                    </button>
                </PopupCard>
            )}

            {confirmInvoicePopup && (
                <PopupCard
                    header={`Confirm Invoice ${confirmInvoicePopup.invoice_number}`}
                    body={`Are you sure you want to confirm invoice ${confirmInvoicePopup.invoice_number} for ${confirmInvoicePopup.supplier_name}? This will move the invoice from Hold to Received status.`}>
                    <button
                        className="btn btnPrimaryOutlined dFlex"
                        onClick={() => setConfirmInvoicePopup(false)}
                        disabled={isConfirmingInvoice}>
                        Cancel
                    </button>
                    <button
                        className="btn btnPrimary dFlex"
                        onClick={() => handleConfirmInvoice(confirmInvoicePopup)}
                        disabled={isConfirmingInvoice}>
                        {isConfirmingInvoice ? 'Confirming...' : 'Confirm Invoice'}
                    </button>
                </PopupCard>
            )}
            
        </>
    )
}

const mapStateToProps = state => {
    return {
        alert: state.alertReducer.alert,
        loginData: state.loginDataReducer?.loginData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addProductReceivingAlertAction: payload =>
            dispatch(addProductReceivingAlertAction(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductReceiving)
